import { GenreContentObjects } from "./genre";
import { LanguageContentObjects } from "./language";
class ContentObjects {
    constructor(sdk) {
        this.language = new LanguageContentObjects(sdk);
        this.genre = new GenreContentObjects(sdk);
    }
}
export default ContentObjects;
//# sourceMappingURL=index.js.map